import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
} from "@mui/material";

export default function ConfirmDisableModal({
    open,
    row,
    onClose,
    onSubmit,
}: {
    open: boolean;
    row?: any;
    onClose: () => void;
    onSubmit: (data: any) => void;
}) {
    const handleSubmit = () => {
        if (!row) return;

        onSubmit(row);
        onClose();
    };

    return (
        <Dialog
            open={open && !!row}
            onClose={onClose}
            maxWidth="lg"
            PaperProps={{
                sx: {
                    backgroundColor: "rgba(247, 249, 251, 1)",
                    borderRadius: 3,
                    py: 3,
                    color: "#FFF",
                },
            }}
        >
            <DialogTitle
                color="rgba(51, 60, 71, 1)"
                sx={{
                    fontWeight: 600,
                    fontSize: 18,
                    pb: 0,
                }}
            >
                Are you sure?
            </DialogTitle>

            <DialogContent
                sx={{
                    fontSize: 14,
                    color: "rgba(51, 60, 71, 1)",
                }}
            >
                This action will disable the current record.
            </DialogContent>

            <DialogActions
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                }}
            >
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        textTransform: "none",
                        color: "black",
                    }}
                >
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    sx={{
                        background: "#EF5350",
                        color: "#FFF",
                        textTransform: "none",
                        boxShadow: "0 2px 4px rgba(239,83,80,0.3)",
                        transition: "all 0.25s ease",
                        "&:hover": {
                            background: "#E57373",
                            boxShadow: "0 4px 10px rgba(239,83,80,0.35)",
                        },
                    }}
                >
                    Disable
                </Button>
            </DialogActions>
        </Dialog>
    );
}